export default __webpack_public_path__ + "static/media/boleto.47f2839a.png";